var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseOval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 45C36.0457 45 45 36.0457 45 25C45 13.9543 36.0457 5 25 5C13.9543 5 5 13.9543 5 25C5 36.0457 13.9543 45 25 45Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6248 18.224C32.8588 17.99 32.8588 17.6095 32.6248 17.3755C32.3908 17.1414 32.0103 17.1414 31.7763 17.3755L25.0002 24.1516L18.2241 17.3755C17.99 17.1414 17.6096 17.1414 17.3755 17.3755C17.1415 17.6095 17.1415 17.99 17.3755 18.224L24.1516 25.0001L17.3755 31.7762C17.1415 32.0103 17.1415 32.3907 17.3755 32.6248C17.4931 32.7424 17.6468 32.8 17.8004 32.8C17.9541 32.8 18.1076 32.7411 18.2253 32.6248L25.0014 25.8486L31.7775 32.6248C31.8951 32.7424 32.0487 32.8 32.2024 32.8C32.3561 32.8 32.5096 32.7411 32.6273 32.6248C32.8613 32.3907 32.8613 32.0103 32.6273 31.7762L25.8512 25.0001L32.6248 18.224Z",
    fill: "#6E6E77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOval);
export default __webpack_public_path__ + "static/media/close-oval.0eeb8c4b16af01487fa272d6d0d7210d.svg";
export { ForwardRef as ReactComponent };